// extracted by mini-css-extract-plugin
export var quoteWrapper = "quote-module--quote-wrapper--4c931";